<template>
    <div class="account-item" :class="{ 'is-open' : isOpen }">

        <div class="content-wrap" :class="`content-wrap_${_uid}`">
            <div v-if="selectedQuestion.pivot.answer">
                <h3 class="js-initial-question" v-text="displayQuestion.question"></h3>
                <p class="js-initial-answer" v-text="selectedQuestion.pivot.answer"></p>
            </div>
            <div v-else>
                <h3 class="js-initial-question">Profile question {{ index + 1 }}</h3>
                <p class="js-initial-answer">Select question below</p>
            </div>
        </div>

        <!-- Open Close Toggle -->
        <span class="account-item-edit-close on-vue" @click="toggle()" v-show="isOpen">
            <svg class="close"><use xlink:href="#close"></use></svg>
            Cancel
        </span>
        <span class="account-item-edit on-vue" @click="toggle()" v-show="!isOpen">
            <svg class="pen"><use xlink:href="#pen"></use></svg>
            Edit
        </span>

        <div class="account-item-inputs alt" :class="`questions-section_${_uid}`">
            <div class="inputs-wrap wide">
                <div class="form__field form__field--select">

                    <select
                        :id="`question_select_${selectedQuestion.id}`"
                        :name="`question_${selectedQuestion.id}`"
                        v-model="selectedQuestion.id"
                        @change="updateValue"
                        class="questions-select">

                        <option disabled>Select Another Question</option>
                        <option v-for="_question in questions"
                                :value="_question.id" v-text="_question.question">
                        </option>

                    </select>
                </div>

                <div class="form__field">
                    <textarea :id="`question_${selectedQuestion.id}`"
                              @keyup="updateValue"
                              rows="3"
                              class="required"
                              v-model="selectedQuestion.pivot.answer">
                    </textarea>
                </div>

            </div>
        </div>
    </div>
</template>
<script>
export default {

    props:['index', 'question', 'questions'],

    data(){
        return {
            selectedQuestion: this.question,
            wrapElementClass: `.questions-section_${this._uid}`,
            contentElementClass: `.content-wrap_${this._uid}`,
            wrapElement: null,
            isOpen: false,
        }
    },

    created() {
        eventBus.$on('form-submitted-success', event => {
            if (this.isOpen) {
                this.toggle()
            }
        });
    },

    mounted(){
        this.wrapElement = $(this.wrapElementClass);
        this.contentElement = $(this.contentElementClass);
    },

    methods: {

        updateValue() {
            // this.$emit('input', this.question)
        },

        toggle() {
            this.isOpen = !this.isOpen;
            this.slide(this.wrapElement)
            this.slide(this.contentElement)
            this.$emit('is-open', this.isOpen)
        },

        slide(element) {
            if (element) {
                if (this.isOpen) {
                    element.slideUp();
                    this.wrapElement.slideDown();
                } else {
                    element.slideDown();
                    this.wrapElement.slideUp();
                }
            }
        },
    },

    computed:{
        displayQuestion(){
            return _.find(this.questions, q => q.id == this.selectedQuestion.id)
        }
    },
}
</script>